import type { parseFilterModel } from '@/lib/createAgGridDatasource';
import { buildDownloadOptions as buildDownloadOptionsShared, type SortColumnState } from '@/lib/downloadOptions';
import type { UsersDownloadOptions } from '@/services/users';
import type { UserFilters, UserSortField } from '@/types';

// Shared by both the global-SuperAdmin and org-scoped user tables — same UserSortField/UserFilters
// domain either way.
export const VALID_SORT_FIELDS: readonly UserSortField[] = [
  'email',
  'full_name',
  'is_super_admin',
  'created_at',
  'updated_at',
];

const VALID_FILTER_FIELDS: readonly (keyof UserFilters)[] = [
  'email',
  'full_name',
  'created_at',
  'updated_at',
  'is_super_admin',
];

export function buildDownloadOptions(
  columnState: readonly SortColumnState[],
  filterModel: Parameters<typeof parseFilterModel>[0],
): UsersDownloadOptions {
  // `is_super_admin` is the one boolean-filtered column on this grid; without this the export
  // sends AG Grid's stringified "true"/"false" instead of a real boolean.
  return buildDownloadOptionsShared(
    columnState,
    filterModel,
    VALID_SORT_FIELDS,
    VALID_FILTER_FIELDS,
    new Set(['is_super_admin']),
  );
}
